import React from 'react'
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import InitialFinancingInformationContainer from '../InitialFinancingInformationContainer/InitialFinancingInformationContainer'
import RefinancingCreditApplicationContainer from '../RefinancingCreditApplicationContainer/Index'
import ErrorPage from '../components/error-page'
import { appActions } from '../../data/store/AppStore'
import { useAppDispatch } from '../../data/store'
import { reportErrorToServer } from '../../error-logger'
import PollingCreditApplicationPage from '../CreditApplicationContainer/PollingCreditApplicationPage'

export default function TopLevelRoutes(): JSX.Element {
  const { t, i18n } = useTranslation()
  const [searchParams] = useSearchParams()
  const lang = searchParams.get('lang')
  const dispatch = useAppDispatch()

  const isMedicardHost = window.location.hostname.includes('medicard.com')

  React.useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang).catch(reportErrorToServer)
      dispatch(appActions.setLanguage(lang))
    }
  }, [lang])

  return (
    <Routes>
      <Route
        path=""
        element={
          <Navigate
            to={`/${
              isMedicardHost ? process.env.REACT_APP_MEDICARD_MERCHANT_ID : process.env.REACT_APP_IFINANCE_MERCHANT_ID
            }`}
          />
        }
      />
      <Route path=":merchantId/*" element={<InitialFinancingInformationContainer />} />
      <Route
        path="creditApplication/:id/coapplicant/*"
        element={<InitialFinancingInformationContainer isCoapplicant />}
      />
      <Route path="creditApplication/:id/*" element={<PollingCreditApplicationPage />} />

      <Route path="refinancingCreditApplication/:id/*" element={<RefinancingCreditApplicationContainer />} />

      <Route path="*" element={<Navigate to="/notFound" />} />
      <Route path="notFound/*" element={<ErrorPage title={t<string>('common.notFound')} />} />
    </Routes>
  )
}
